import * as React from "react";
import Grid from "@mui/material/Grid";
import { Autocomplete, TextField } from "@mui/material";
import { limitApiCall } from "../../Utils/util-service";
import { getSearchProduct } from "../../Utils/vendor-customer-service";

function SearchAutoComplete(props) {
  const { getProductFromAutoComplete, disablePortal = true, label } = props;
  const [searchText, setSearchText] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [products, setProducts] = React.useState([]);
  const [noRcrd, setNoRcrd] = React.useState(false);
  React.useEffect(() => {
    setNoRcrd(false);
    if (searchText?.length > 1 && searchText?.length < 249) {
      limitSearch(searchText);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const fetchSearch = (text) => {
    setLoading(true);
    try {
      let res = getSearchProduct(text);
      res.then((data) => {
        if (data.status === 200) {
          setProducts(data?.data?.predictiveSearch?.products || []);
          setLoading(false);
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const limitSearch = React.useCallback(limitApiCall(fetchSearch), []);

  const handleChange = (e, product) => {
    getProductFromAutoComplete(product);
  };
  return (
    <Grid container>
      <Grid item xs={12} md={12} lg={12}>
        <Autocomplete
          onChange={handleChange}
          loading={loading}
          disableClearable
          disablePortal={disablePortal}
          autoFocus
          id="combo-box-demo"
          isOptionEqualToValue={(option, value) =>
            value === undefined || option?.title === value?.title
          }
          getOptionLabel={(option) => option.title}
          options={products}
          ListboxProps={{
            style: { maxHeight: 280 },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              fullWidth
            />
          )}
        />
      </Grid>
    </Grid>
  );
}

export default SearchAutoComplete;
